import { render, staticRenderFns } from "./LtIcon.vue?vue&type=template&id=0a478c8c&"
import script from "./LtIcon.vue?vue&type=script&lang=ts&"
export * from "./LtIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports